import { connect } from 'react-redux';
import { ItemsView } from './ItemsView';
import { popularCarriersSelector, fetchPopularCarriersIfNeeded as fetchPopular } from '../../../data/popular-carriers';
import { fetchCarriersIfNeeded as fetchAll, carriersSelector } from '../../../data/carriers';
import {
    chooseCarrier,
    chooseNonInsuranceOption,
    showAllForTab,
    changeFocus,
    viewPlanTab,
    viewBcbsTab,
} from '../../../data/dropdown-state/dropdownStateActions';
import { getDropdownState } from '../../../data/dropdown-state';
import { TAB, CARRIER } from '../../../constants';

export function mapStateToProps(state) {
    const baseConfig = {
        itemName: 'carriers',
        isLoading: true,
        popularItems: [],
        allItems: [],
    };

    let allCarriers = carriersSelector(state);
    let popularCarriers = popularCarriersSelector(state);
    const dropdownState = getDropdownState(state);

    if ((!popularCarriers || !popularCarriers.length)
        && (!allCarriers || !allCarriers.length)) {
        return baseConfig;
    }

    if (allCarriers.length < 5) {
        popularCarriers = allCarriers;
        allCarriers = [];
    }

    return {
        ...baseConfig,
        ...dropdownState,
        isLoading: false,
        popularItems: popularCarriers || baseConfig.popularItems,
        allItems: allCarriers || baseConfig.allCarriers,
        selected: dropdownState.canSeeBcbs
            ? { id: CARRIER.BLUE_CROSS_BLUE_SHIELD }
            : dropdownState.carrier || { },
        tab: dropdownState.tab,
        showAll: dropdownState.showAll[TAB.INSURANCE] === true,
        nextTab: props => () => {
            if (dropdownState.canSeeBcbs) {
                props.viewBcbsTab();
            } else if (!dropdownState.planDisabled) {
                props.viewPlanTab();
            }
        },
        showChooseLaterOption: true,
    };
}

export const mapDispatchToProps = {
    fetchPopular,
    fetchAll,
    clickHandler: chooseCarrier,
    chooseNonInsuranceOption,
    showAllForTab,
    changeFocus,
    viewPlanTab,
    viewBcbsTab,
};

export const CarriersConnector = connect(
    mapStateToProps,
    mapDispatchToProps
)(ItemsView);
